module.exports = __webpack_public_path__ + "assets/1-tech-sales-jobs.c471b73b.png";